import { useMutation } from "@tanstack/react-query";
import { updatePageMaintenanceMode } from "../api/updatePageMaintenanceMode";
import { invalidatePagesListByBrandsQuery } from "../queries/usePagesListByBrandQuery";

type Params = {
  pageId: string;
  isMaintenanceMode: boolean;
  maintenanceModeDescription?: string;
};

export const useUpdatePageMaintenanceModeMutation = (brandId: string) => {
  return useMutation({
    mutationFn: async ({
      isMaintenanceMode,
      pageId,
      maintenanceModeDescription,
    }: Params) => {
      return await updatePageMaintenanceMode({
        isMaintenanceMode,
        maintenanceModeDescription,
        brandId,
        pageId,
      });
    },
    onSuccess: () => {
      invalidatePagesListByBrandsQuery(brandId);
    },
    onError: (e) => {
      console.error("Error occurred when updating page", e);
    },
  });
};
